import { Provider } from '@angular/core';

import { NotificationUseCasesImpl } from '@app/domain/use-cases/notification/notification.use-cases';
import { NOTIFICATION_USE_CASES } from '@app/domain/use-cases/notification/notification.use-cases.contract';

export const notificationUseCasesProvider: Provider = {
  provide: NOTIFICATION_USE_CASES,
  useClass: NotificationUseCasesImpl
};
